import Post from 'Post';
import React, { useEffect, useState } from 'react';

export const Index = () => {
  const [posts, setPosts] = useState([]);

  const url =
    process.env.REACT_APP_NODE_ENV === 'production'
      ? process.env.REACT_APP_SERVER_PROD_URL
      : 'http://localhost:4000';

  useEffect(() => {
    fetch(`${url}/post`).then((response) => {
      response.json().then((posts) => {
        setPosts(posts);
      });
    });
  }, []);
  return <>{posts.length > 0 && posts.map((post) => <Post {...post} />)}</>;
};
